import { I18n } from '@calendly/i18n';
import { Link } from '@calendly/ui/components/link';
import { colorTextInverseStandard } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { openChat } from 'components/external/ada_chat_bot';
const listCss = "l1jwzglp";
const List = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} className={classNames(listCss, props.className)} />;
});
const listItemCss = "l89ufpq";
const ListItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(listItemCss, props.className)} />;
});
const styledLinkCss = "stqhy14";
const StyledLink = forwardRef((props, ref) => {
  const style = {
    color: colorTextInverseStandard
  };
  return <Link ref={ref} {...props} style={style} className={classNames(styledLinkCss, props.className)} />;
});
const externalLinkCss = "elmd3pg";
const ExternalLink = forwardRef((props, ref) => {
  const target = '_blank';
  const rel = 'noopener noreferrer';
  return <StyledLink ref={ref} {...props} target={target} rel={rel} className={classNames(externalLinkCss, props.className)} />;
});
const chatLinkCss = "cec0ydq";
const ChatLink = forwardRef((props, ref) => {
  const as = 'button';
  return <StyledLink ref={ref} {...props} as={as} className={classNames(chatLinkCss, props.className)} />;
});
export const OutlookTooltip = () => <div data-component="provider-tooltip-outlook">
    <p>{I18n.t('publisher.calendar.outlook.tooltip.learn_more')}</p>
    <List>
      <ListItem>
        <ExternalLink href="https://calendly.com/help/how-to-connect-your-office-365-or-outlook-com-calendar">
          {I18n.t('publisher.calendar.outlook.tooltip.article1')}
        </ExternalLink>
      </ListItem>
      <ListItem>
        <ExternalLink href="https://calendly.com/help/outlook-plug-in-faq">
          {I18n.t('publisher.calendar.outlook.tooltip.article2')}
        </ExternalLink>
      </ListItem>
    </List>
    <p>
      {I18n.t('publisher.calendar.outlook.tooltip.need_assistance')}
      <ChatLink onClick={() => openChat()}>
        {I18n.t('publisher.calendar.outlook.tooltip.chat_with_us')}
      </ChatLink>
    </p>
  </div>;

require("./tooltips.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./tooltips.js");